import React, { Component } from "react";
import Colors from "../Colors/Colors";
import "./palette.css";

class Palette extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
    };
  }
  render() {
    let paletteName;
    let colors;
    if (this.props.results.length > 0) {
      paletteName = this.props.results.map((palette, i) => {
        colors = palette.colors;
        return (
          <div key={palette.id} className="palette-container shadow-xl">
            <span className="delete-button" onClick={()=>{this.props.deletePalette(palette.id)}}>x</span>
            <h3>{palette.name}</h3>
            <Colors colors={colors} />
          </div>
        );
      });
    }
    return <div className="saved-palette">{paletteName}</div>;
  }
}

export default Palette;
